import React, { useEffect, useMemo, useState } from "react";
import * as bie from "react-bootstrap";
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from "formik";
import { config } from "../CommonUtils/CommonURLS";
import { CommonAxiosGet } from "../CommonUtils/CommonAxios";
import CommonReactTable from "../CommonUtils/CommonReactTable";
export default function DeptWiseStatusReport() {
    const facultyDetailsFormik = useFormik({
        initialValues: { university: "" },
        enableReinitialize: true,
        onSubmit: (val) => { console.log("Submit", val); },
    });
    const [showDetails, setShowDetails] = useState(null);



    const [deptdata, setDeptdata] = useState([]);

    function GetDeptData() {
        const url = `${config.url.FAC_URL}getUnvWiseDeptCount`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01" && res?.data?.data?.length > 0) {
                setDeptdata(res?.data?.data);
                setShowDetails(true);

            } else {
                setDeptdata([]);
                setShowDetails(true);

            }
        });
    }


    useEffect(() => {
        GetDeptData();
    }, [])
    const SubjectReportColumns = [
        {
            id: "slNo",
            header: "Sl.No",
            cell: ({ row }) => row.index + 1,

        },
        {
            id: "univ_name",
            header: "Name of the University ",
            accessorKey: "univ_name",
            // meta: { style: { textAlign: "left" } },
            Footer: "Total",

        },
        {
            id: "dept_count_maker",
            header: "Maker ",
            accessorKey: "dept_count_maker",
            Footer: true,
            // meta: { style: { textAlign: "left" } },


        },
        {
            id: "approved_dept_count",
            header: "Approver ",
            accessorKey: "approved_dept_count",
            Footer: true,
            // meta: { style: { textAlign: "left" } },

        },
        {
            id: "dept_count_maker",
            header: "Total",
            accessorKey: "dept_count_maker",
            Footer: true,

        },


    ];


    return (
        <>

            <div className="faculty-form-wrapper">
                <div className="faculty-card">
                    <div className="overal-stathead"><span>University Wise - Department Completion Status</span></div>

                    <FormikProvider value={facultyDetailsFormik}>
                        <Form onSubmit={facultyDetailsFormik?.handleSubmit} onChange={facultyDetailsFormik?.handleChange}>

                            {deptdata?.length > 0 ? (

                                <CommonReactTable
                                    data={deptdata}
                                    columns={SubjectReportColumns}
                                    filename="University Wise - Department Completion Status"
                                    headerName="University Wise - Department Completion Status"
                                    showFooter={true}
                                    showPagination={false}
                                    showExcel={true}
                                    showPrint={true}
                                    excelFileName="University Wise - Department Completion Status"
                                />
                            ) : (
                                showDetails == true &&
                                deptdata.length === 0 && (
                                    <div
                                        style={{
                                            textAlign: "center",
                                            color: "#d32f2f",
                                            marginTop: "20px",
                                            fontSize: "18px",
                                            fontWeight: "600",
                                        }}
                                    >
                                        ***** No Data Found *****
                                    </div>
                                )
                            )}


                        </Form>
                    </FormikProvider>

                </div>
            </div >

        </>

    )
}
